import React from 'react'
import Tooltip from 'rc-tooltip'
import { ValueOrArray } from '@feedyou/utils'
import _ from 'lodash'

interface Props {
  align?: object
  placement?: string
  mouseEnterDelay?: number
  children: React.ReactNode
  overlayStyle?: React.CSSProperties
  trigger?: ('hover' | 'click' | 'focus')[]
  overlay?: ValueOrArray<string | JSX.Element>
}

export const TooltipWrapper: React.FC<Props> = ({
  align,
  trigger,
  overlay,
  children,
  placement,
  overlayStyle,
  mouseEnterDelay
}) => {
  if (overlay === undefined || _.isEmpty(overlay)) {
    return <>{children}</>
  }

  return (
    <Tooltip
      align={align}
      trigger={trigger}
      overlay={overlay}
      placement={placement}
      overlayStyle={overlayStyle}
      mouseEnterDelay={mouseEnterDelay}
    >
      {children}
    </Tooltip>
  )
}
